// @flow
import { path } from 'ramda'

import { getRadioChannelCountries } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_RADIO_CHANNEL_COUNTRIES = 'radioChannels/FETCH_COUNTRIES'

const fetchRadioChannelCountriesAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_RADIO_CHANNEL_COUNTRIES,
    payload: getRadioChannelCountries(publicApi, serviceSpec),
    meta: {
      ttl,
    },
  })
}

// eslint-disable-next-line complexity
export const fetchRadioChannelCountries = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchRadioChannelCountriesAction(serviceSpec))

  const state = getState()
  const expires = path(['channelCountries', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchRadioChannelCountriesAction(serviceSpec))
}
